module.exports = __webpack_public_path__ + "./img/pdf.15f139607966be0ed3fa2f20c546d7bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/pdf.png
// module id = ./src/containers/Briefcase/entry/icons/pdf.png
// module chunks = 0